module.exports = __webpack_public_path__ + "static/img/IMG_20150310_135945.26c284d1.jpg";